import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

const STORAGE_KEY = 'tolly.admin.token';
const ADMIN_KEY = 'tolly.admin.user';

export function saveAuth(token, admin) {
  localStorage.setItem(STORAGE_KEY, token);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
}
export function clearAuth() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(ADMIN_KEY);
}
export function getToken() {
  return localStorage.getItem(STORAGE_KEY);
}
export function getAdmin() {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_KEY) || 'null');
  } catch { return null; }
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== 'undefined') {
      const path = window.location.pathname;
      if (path.startsWith('/admin') && !path.endsWith('/login')) {
        clearAuth();
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);
